module.exports = __webpack_public_path__ + "8e8a4e3ed91e16cfc91d5da7707ac39b.png";